import gql from 'graphql-tag';

export const GET_SALESPERSON_INFO = gql`
	query GetSalesperson($id: String!) {
		user(id: $id) {
			id
			name
			email
			phoneNumber
		}
	}
`;

export const UPDATE_SALESPERSON_INFO = gql`
	mutation UpdateSalespersonInfo($id: String!, $name: String, $email: String, $phoneNumber: String) {
		updateUser(id: $id, name: $name, email: $email, phoneNumber: $phoneNumber) {
			id
			name
			email
			phoneNumber
		}
	}
`;
